import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import './assets/js/script';
import 'animate.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";

// Components
import General from './comps/generals'
import Header from "./comps/header";
import Slider from "./comps/slider";
import About from "./comps/about";
import Clients from "./comps/clients";
import Footer from "./comps/footer";

const MAPBOX_TOKEN = "pk.eyJ1Ijoia2hhbGVkbW45NSIsImEiOiJja2R2Z2NwOHEyaTg0MnF0dmdyazlrdDY1In0.3pIEAtkbZtYPlH-G0vZKMQ";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <General />
    <Header />
    <Slider />
    <About />
    <Clients />
    <Footer token={MAPBOX_TOKEN} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*
=== Project Notes ===

* I Used Reactstrap 


*/
